import React from 'react'

import {
  AppearingWrapper,
  CTAParagraph,
  SectionContainer,
} from 'Components/Blocks'
import { Column } from 'Components/UI'

import {
  LANDING_CONTENT_PX,
  LANDING_CONTENT_WIDTH_PX,
  LANDING_SECTION_GAP,
  LANDING_SECTION_PY,
} from 'Constants/Landing'

import Gallery from './Gallery'
import Title from './Title'

function WhoIsEmajinForSection() {
  return (
    <SectionContainer px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Column
          alignCenter
          fullWidth
          gap={LANDING_SECTION_GAP}
          maxWidth={LANDING_CONTENT_WIDTH_PX}
          pt={LANDING_SECTION_PY}
        >
          <Title />

          <Gallery />

          <CTAParagraph
            centered
            maxWidth={825}
            text={
              <>
                If you&#39;ve built a successful business and want to enjoy what
                you&#39;ve created while still opening new doors, Emajin is the
                room for you.
              </>
            }
          />
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default WhoIsEmajinForSection
